<template>
  <div>
    <NBar title="客服微信" :top="true"/>
    <div class="subject">
      <div class="title" v-if="addressList.length == 1 && addressList[0].id == 0">默认设置</div>
      <div class="title" v-else>场地名称:{{addressList[0].name}}</div>
      <div class="title" v-if="addressList.length > 1">您正在对{{addressList.length}}个场地进行客服微信的设置</div>
      <span class="text">客服名称（限8个字）</span>
      <nut-textinput v-model="form.serviceName" placeholder="请输入客服名称，如：平台客服微信" :clearBtn="false" :disabled="false"
                     class="input"/>
      <div class="text-div">
        <span class="text">微信客户二维码（文件小于200kb）</span>
        <span class="right-text" @click="show = true">规范样例 ></span>
      </div>
      <div class="upload-img">
        <nut-imagepicker @imgMsg="imgMsg" :max="1"></nut-imagepicker>
        <div class="upload-tips">
          <div class="wrap">
            <p>图片只能包含正方形的二维码，</p>
            <p>不能有其它信息或空白。</p>
            <p>请参考规范样例。</p>
          </div>
          <div class="arrow-icon"></div>
        </div>
      </div>
      <nut-button block class="btn" @click="submit">保存</nut-button>
      <div class="result">预览效果</div>
      <nut-popup :style="{ padding: '30px 50px' }" v-model="show" closeable close-icon="cross">
        <p class="top-title">规范的二维码图片</p>
        <img class="qrCode"
             src="data:image/png;base64,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">
      </nut-popup>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WeChatSet',
  props: ['type', 'data'],
  data () {
    return {
      user: {},
      addressList: [{}],
      show: false,
      imgs: [],
      form: {
        id: null,
        addressIds: [],
        merId: null,
        storeId: null,
        serviceName: '',
        serviceCodeUrl: '',
      },
      url: '',
    }
  },
  mounted () {
    this.form.merId = this.$api.merId
    this.form.storeId = this.$api.storeId
    this.user = this.$api.user
    if (this.data != null) {
      let data = JSON.parse(decodeURIComponent(this.data))
      this.addressList = data
      this.addressList.forEach(item => {
        this.form.addressIds.push(item.id)
      })
      if (this.addressList.length == 1) {
        this.getData()
      }
    }
  },
  methods: {
    getData () {
      this.$api.post({
        url: '/device/api/system/device-address-system-set/find',
        data: {
          merId: this.user.merId,
          storeId: this.user.storeId,
          addressId: this.addressList[0].id
        }
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          this.$util.ofData(this.form, res.data)
        }
      })
    },
    imgMsg (data) {
      if (data.msg.length > 0) {
        data.msg.forEach(item => {
          this.imgs.push(item)
        })
      }
    },
    //发布评论
    submit: function () {
      if (this.$util.isArrOrNull(this.form.serviceName)) {
        this.$toast.warn('请输入客服名称!')
        return
      }
      if (this.imgs != null && this.imgs.length > 0) {
        this.upload(this.imgs, 0)
      } else {
        this.save()
      }
    },
    save: function () {
      if (this.url.length > 0) {
        this.form.serviceCodeUrl = this.url.substring(0, this.url.length - 1)
      }
      this.$api.post({
        url: '/device/api/system/device-address-system-set/save',
        data: this.form
      }).then(() => {
        setTimeout(() => {
          if (this.type != null) {
            this.$router.go(-2)
          } else {
            this.$router.go(-1)
          }
        }, 2000)
      })
    },
    //上传文件
    upload: function (imgs, i) {
      if (imgs[i].size / 1024 / 1024 > 2) {
        this.$toast.warn('上传图片大小不能超过 2MB')
        return false
      }
      let data = new FormData()
      let file = new File(['file'], imgs[i].path)
      data.append('file', file)
      data.append('folder', 'image')
      this.$api.upload({
        url: '/file/upload/img',
        data: data
      }).then(res => {
        i++
        this.url = this.url + res.data.filePath + ',' + res.data.fileName + ';'
        if (i < imgs.length) {
          this.upload(imgs, i, this.form)
        } else {
          this.form.serviceCodeUrl = this.url.substring(0, this.url.length - 1)
          this.save(this.form)
        }
      })
      return false
    },
  }
}
</script>

<style scoped>
  .subject {
    margin: 0 15px;
  }

  .subject .title {
    height: 35px;
    line-height: 35px;
    margin-top: 5px;
    color: #848484;
  }

  .subject .text {
    font-size: 14px;
  }

  .subject .input {
    margin: 5px 0;
  }

  .subject .text-div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .subject .text-div .right-text {
    color: #409EFF;
  }

  .subject .upload-img {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    padding: 20px;
    margin-top: 5px;
    border-radius: 5px;
  }

  .subject .upload-img .upload-tips {
    position: relative;
  }

  .subject .upload-img .upload-tips .wrap {
    border-radius: 5px;
    background: #f6f6f6;
    color: #999;
    padding: 1px 15px;
  }

  .subject .upload-img .upload-tips .arrow-icon {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #f6f6f6;
    left: -10px;
    top: 50%;
    margin-top: -10px;
  }

  .subject .btn {
    margin-top: 20px;
    border-radius: 5px;
  }

  .subject .result {
    text-align: center;
    margin-top: 30px;
    font-size: 15px;
    color: #409EFF;
  }

  .top-title {
    text-align: center;
    font-size: 16px;
  }

  .qrCode {
    width: 175px;
    height: auto;
  }

  >>> .nut-button {
    background: #409EFF;
  }

  >>> .nut-imagepicker .img-list .add-icon {
    border: 1px dashed #409EFF;
  }

  >>> .nut-imagepicker .img-list .add-icon i {
    color: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/WeChatSet.vue